import { SvgIcon } from "./SvgIcon";

export const ChatGPTIcon: SvgIcon = ({
  width = 41,
  height = 41,
  strokeColor = "text-white",
  strokeWidth = 1.5,
  fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="chatgpt-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 41 41"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <title>ChatGPT</title>
    <text x="-9999" y="-9999">
      ChatGPT
    </text>
    <path
      d="M37.5324 16.8707C37.9808 15.5241 38.1363 14.0974 37.9886 12.6859C37.8409 11.2744 37.3934 9.91076 36.676 8.68622C35.6126 6.83404 33.9882 5.3676 32.0373 4.4985C30.0864 3.62941 27.9098 3.40259 25.8215 3.85078C24.8796 2.7893 23.7219 1.94125 22.4257 1.36341C21.1295 0.785575 19.7249 0.491269 18.3058 0.500197C16.1708 0.495044 14.0893 1.16803 12.3614 2.42214C10.6335 3.67624 9.34853 5.44666 8.6917 7.47815C7.30085 7.76286 5.98686 8.3414 4.8377 9.17505C3.68854 10.0087 2.73073 11.0782 2.02839 12.312C0.956464 14.1591 0.498905 16.2988 0.721698 18.4228C0.944492 20.5467 1.83612 22.5449 3.268 24.1293C2.81966 25.4759 2.66413 26.9026 2.81182 28.3141C2.95951 29.7256 3.40701 31.0892 4.12437 32.3138C5.18791 34.1659 6.8123 35.6322 8.76321 36.5013C10.7141 37.3704 12.8907 37.5973 14.9789 37.1492C15.9208 38.2107 17.0786 39.0587 18.3747 39.6366C19.6709 40.2144 21.0755 40.5087 22.4946 40.4998C24.6307 40.5054 26.7133 39.8321 28.4418 38.5772C30.1704 37.3223 31.4556 35.5506 32.1119 33.5179C33.5027 33.2332 34.8167 32.6547 35.9659 31.821C37.115 30.9874 38.0728 29.9178 38.7752 28.684C39.8458 26.8371 40.3023 24.6979 40.0789 22.5748C39.8556 20.4517 38.9639 18.4544 37.5324 16.8707ZM22.4978 37.8849C20.7443 37.8874 19.0459 37.2733 17.6994 36.1501C17.7601 36.117 17.8666 36.0586 17.936 36.0161L25.9004 31.4156C26.1003 31.3019 26.2663 31.137 26.3813 30.9378C26.4964 30.7386 26.5563 30.5124 26.5549 30.2825V19.0542L29.9213 20.998C29.9389 21.0068 29.9541 21.0198 29.9656 21.0359C29.977 21.052 29.9842 21.0707 29.9867 21.0902V30.3889C29.9842 32.375 29.1946 34.2791 27.7909 35.6841C26.3872 37.0892 24.4838 37.8806 22.4978 37.8849ZM6.39227 31.0064C5.51397 29.4888 5.19742 27.7107 5.49804 25.9832C5.55718 26.0187 5.66048 26.0818 5.73461 26.1244L13.699 30.7248C13.8975 30.8408 14.1233 30.902 14.3532 30.902C14.583 30.902 14.8088 30.8408 15.0073 30.7248L24.731 25.1103V28.9979C24.7321 29.0177 24.7283 29.0376 24.7199 29.0556C24.7115 29.0736 24.6988 29.0893 24.6829 29.1012L16.6317 33.7497C14.9096 34.7416 12.8643 35.0097 10.9447 34.4954C9.02506 33.9811 7.38785 32.7263 6.39227 31.0064ZM4.29707 13.6194C5.17156 12.0998 6.55279 10.9364 8.19885 10.3327C8.19885 10.4013 8.19491 10.5228 8.19491 10.6071V19.808C8.19351 20.0378 8.25334 20.2638 8.36823 20.4629C8.48312 20.6619 8.64893 20.8267 8.84863 20.9404L18.5723 26.5542L15.206 28.4979C15.1894 28.5089 15.1703 28.5155 15.1505 28.5173C15.1307 28.5191 15.1107 28.516 15.0924 28.5082L7.04046 23.8557C5.32135 22.8601 4.06716 21.2235 3.55289 19.3046C3.03862 17.3858 3.30624 15.3413 4.29707 13.6194ZM31.955 20.0556L22.2312 14.4411L25.5976 12.4981C25.6142 12.4872 25.6333 12.4805 25.6531 12.4787C25.6729 12.4769 25.6928 12.4801 25.7111 12.4879L33.7631 17.1364C34.9967 17.849 36.0017 18.8982 36.6606 20.1613C37.3194 21.4244 37.6047 22.849 37.4832 24.2684C37.3617 25.6878 36.8382 27.0432 35.9743 28.1759C35.1103 29.3086 33.9415 30.1717 32.6047 30.6641C32.6047 30.5947 32.6047 30.4733 32.6047 30.3889V21.188C32.6066 20.9586 32.5474 20.7328 32.4332 20.5338C32.319 20.3348 32.154 20.1698 31.955 20.0556ZM35.3055 15.0128C35.2464 14.9765 35.1431 14.9142 35.069 14.8717L27.1045 10.2712C26.906 10.1554 26.6803 10.0943 26.4504 10.0943C26.2206 10.0943 25.9948 10.1554 25.7963 10.2712L16.0726 15.8858V11.9982C16.0715 11.9783 16.0753 11.9585 16.0837 11.9405C16.0921 11.9225 16.1048 11.9068 16.1207 11.8949L24.1719 7.25025C25.4053 6.53903 26.8158 6.19376 28.2383 6.25482C29.6608 6.31589 31.0364 6.78077 32.2044 7.59508C33.3723 8.40939 34.2842 9.53945 34.8334 10.8531C35.3826 12.1667 35.5464 13.6095 35.3055 15.0128ZM14.2424 21.9419L10.8752 19.9981C10.8576 19.9893 10.8423 19.9763 10.8309 19.9602C10.8195 19.9441 10.8122 19.9254 10.8098 19.9058V10.6071C10.8107 9.18295 11.2173 7.78848 11.9819 6.58696C12.7466 5.38544 13.8377 4.42659 15.1275 3.82264C16.4173 3.21869 17.8524 2.99464 19.2649 3.1767C20.6775 3.35876 22.0089 3.93941 23.1034 4.85067C23.0427 4.88379 22.937 4.94215 22.8668 4.98473L14.9024 9.58517C14.7025 9.69878 14.5366 9.86356 14.4215 10.0626C14.3065 10.2616 14.2466 10.4877 14.2479 10.7175L14.2424 21.9419ZM16.071 17.9991L20.4018 15.4978L24.7325 17.9975V22.9985L20.4018 25.4983L16.071 22.9985V17.9991Z"
      fill="currentColor"
      strokeWidth={strokeWidth}
    ></path>
  </svg>
);

export const PromptIcon: SvgIcon = ({
  width = 41,
  height = 41,
  strokeColor = "text-white",
  strokeWidth = 3,
  fillColor = "#FF0033",
  classes
}) => (
  <svg
    data-cy="chatgpt-prompt-icon"
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 39 22"
    className={`stroke-current ${strokeColor} ${classes}`}
  >
    <path d="M16 20H37" stroke="#666666" strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M16 11H37" stroke="#666666" strokeWidth={strokeWidth} strokeLinecap="round" />
    <path d="M16 2H37" stroke="#666666" strokeWidth={strokeWidth} strokeLinecap="round" />
    <path
      d="M10.995 1.25963C11.0594 2.02012 10.4966 2.6818 9.74045 2.74625L9.39675 2.77632C7.97038 2.89233 6.87482 4.08248 6.87482 5.51325V9.62508H8.24963C9.01008 9.62508 9.62445 10.2395 9.62445 11C9.62445 11.7605 9.01008 12.3749 8.24963 12.3749H6.87482V16.4867C6.87482 17.9175 7.97038 19.1076 9.39675 19.2279L9.74045 19.258C10.4966 19.3182 11.0594 19.9798 10.995 20.7403C10.9305 21.5008 10.2689 22.0594 9.51275 21.9949L9.16904 21.9649C7.704 21.8446 6.41082 21.1528 5.5 20.1216C4.58918 21.1528 3.30029 21.8446 1.83096 21.9649L1.48725 21.9949C0.731102 22.0594 0.0651741 21.4965 0.00502586 20.7403C-0.0551224 19.9841 0.503397 19.3182 1.25955 19.258L1.60325 19.2279C3.02962 19.1076 4.12518 17.9175 4.12518 16.4867V12.3749H2.75036C1.98992 12.3749 1.37555 11.7605 1.37555 11C1.37555 10.2395 1.98992 9.62508 2.75036 9.62508H4.12518V5.51325C4.12518 4.08248 3.02962 2.89233 1.60325 2.77203L1.25955 2.74195C0.503397 2.6775 -0.0594187 2.01583 0.00502586 1.25963C0.0694704 0.50343 0.731101 -0.0594222 1.49155 0.00502654L1.83525 0.0351026C3.30029 0.155407 4.58918 0.847157 5.5 1.87834C6.41082 0.847157 7.69971 0.159704 9.16904 0.0351026L9.51275 0.00502654C10.2689 -0.0594222 10.9305 0.50343 10.995 1.25963Z"
      fill="#666666"
    />
  </svg>
);

export const AccountIcon: SvgIcon = ({
  width = 41,
  height = 41,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 43 43"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path d="M33.5098 32.2668C31.6537 29.0418 28.1684 26.875 24.1875 26.875H18.8125C14.8316 26.875 11.3463 29.0418 9.49023 32.2668C12.4465 35.559 16.7297 37.625 21.5 37.625C26.2703 37.625 30.5535 35.5506 33.5098 32.2668ZM0 21.5C0 15.7978 2.26517 10.3292 6.2972 6.2972C10.3292 2.26517 15.7978 0 21.5 0C27.2022 0 32.6708 2.26517 36.7028 6.2972C40.7348 10.3292 43 15.7978 43 21.5C43 27.2022 40.7348 32.6708 36.7028 36.7028C32.6708 40.7348 27.2022 43 21.5 43C15.7978 43 10.3292 40.7348 6.2972 36.7028C2.26517 32.6708 0 27.2022 0 21.5ZM21.5 22.8438C23.1037 22.8438 24.6418 22.2067 25.7758 21.0727C26.9098 19.9387 27.5469 18.4006 27.5469 16.7969C27.5469 15.1931 26.9098 13.6551 25.7758 12.5211C24.6418 11.3871 23.1037 10.75 21.5 10.75C19.8963 10.75 18.3582 11.3871 17.2242 12.5211C16.0902 13.6551 15.4531 15.1931 15.4531 16.7969C15.4531 18.4006 16.0902 19.9387 17.2242 21.0727C18.3582 22.2067 19.8963 22.8438 21.5 22.8438Z" />
  </svg>
);

export const UserIcon: SvgIcon = ({
  width = 41,
  height = 41,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 35 35"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <circle cx="17.5" cy="17.5" r="17.5" fill="#BFBFBF" />
    <mask
      id="mask0_161_923"
      style={{ maskType: "alpha" }}
      maskUnits="userSpaceOnUse"
      x="0"
      y="0"
      width="35"
      height="35"
    >
      <circle cx="17.5" cy="17.5" r="17.5" fill="#BFBFBF" />
    </mask>
    <g mask="url(#mask0_161_923)">
      <path
        d="M17.4999 21.5832C19.268 21.5832 20.9637 20.8764 22.214 19.6183C23.4642 18.3603 24.1666 16.654 24.1666 14.8748C24.1666 13.0957 23.4642 11.3894 22.214 10.1313C20.9637 8.87327 19.268 8.1665 17.4999 8.1665C15.7318 8.1665 14.0361 8.87327 12.7859 10.1313C11.5356 11.3894 10.8333 13.0957 10.8333 14.8748C10.8333 16.654 11.5356 18.3603 12.7859 19.6183C14.0361 20.8764 15.7318 21.5832 17.4999 21.5832ZM15.1197 24.0988C9.9895 24.0988 5.83325 28.281 5.83325 33.4433C5.83325 34.3028 6.52596 34.9998 7.38013 34.9998H27.6197C28.4739 34.9998 29.1666 34.3028 29.1666 33.4433C29.1666 28.281 25.0103 24.0988 19.8801 24.0988H15.1197Z"
        fill="#666666"
      />
    </g>
  </svg>
);

export const MKIChatBotIcon: SvgIcon = ({
  width = 20,
  height = 20,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes = "",
  onClick
}) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 69 69"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      d="M67.75 34.5C67.75 52.8635 52.8635 67.75 34.5 67.75C16.1365 67.75 1.25 52.8635 1.25 34.5C1.25 16.1365 16.1365 1.25 34.5 1.25C52.8635 1.25 67.75 16.1365 67.75 34.5Z"
      fill="white"
      stroke="#DEDEDE"
      strokeWidth="2.5"
    />
    <circle cx="43.8688" cy="43.8705" r="11.713" fill="#A3A5A8" fillOpacity="0.7" />
    <circle cx="30.9861" cy="30.9861" r="17.5694" fill="#00AEEF" fillOpacity="0.7" />
  </svg>
);

export const ListIcon: SvgIcon = ({
  width = 41,
  height = 41,
  strokeColor = "text-white",
  fillColor = "#00000000",
  classes
}) => (
  <svg
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 47 39"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <path
      d="M4.54839 9C5.75469 9 6.91159 8.5259 7.76458 7.68198C8.61757 6.83807 9.09677 5.69347 9.09677 4.5C9.09677 3.30653 8.61757 2.16193 7.76458 1.31802C6.91159 0.474106 5.75469 0 4.54839 0C3.34208 0 2.18518 0.474106 1.33219 1.31802C0.479204 2.16193 0 3.30653 0 4.5C0 5.69347 0.479204 6.83807 1.33219 7.68198C2.18518 8.5259 3.34208 9 4.54839 9ZM16.6774 1.5C15.0002 1.5 13.6452 2.84062 13.6452 4.5C13.6452 6.15938 15.0002 7.5 16.6774 7.5H43.9677C45.645 7.5 47 6.15938 47 4.5C47 2.84062 45.645 1.5 43.9677 1.5H16.6774ZM16.6774 16.5C15.0002 16.5 13.6452 17.8406 13.6452 19.5C13.6452 21.1594 15.0002 22.5 16.6774 22.5H43.9677C45.645 22.5 47 21.1594 47 19.5C47 17.8406 45.645 16.5 43.9677 16.5H16.6774ZM16.6774 31.5C15.0002 31.5 13.6452 32.8406 13.6452 34.5C13.6452 36.1594 15.0002 37.5 16.6774 37.5H43.9677C45.645 37.5 47 36.1594 47 34.5C47 32.8406 45.645 31.5 43.9677 31.5H16.6774ZM4.54839 39C5.75469 39 6.91159 38.5259 7.76458 37.682C8.61757 36.8381 9.09677 35.6935 9.09677 34.5C9.09677 33.3065 8.61757 32.1619 7.76458 31.318C6.91159 30.4741 5.75469 30 4.54839 30C3.34208 30 2.18518 30.4741 1.33219 31.318C0.479204 32.1619 0 33.3065 0 34.5C0 35.6935 0.479204 36.8381 1.33219 37.682C2.18518 38.5259 3.34208 39 4.54839 39ZM9.09677 19.5C9.09677 18.9091 8.97913 18.3239 8.75055 17.7779C8.52197 17.232 8.18694 16.7359 7.76458 16.318C7.34223 15.9002 6.84082 15.5687 6.28898 15.3425C5.73714 15.1164 5.14569 15 4.54839 15C3.95108 15 3.35963 15.1164 2.80779 15.3425C2.25596 15.5687 1.75455 15.9002 1.33219 16.318C0.909835 16.7359 0.574803 17.232 0.346225 17.7779C0.117647 18.3239 -8.9005e-09 18.9091 0 19.5C-8.9005e-09 20.0909 0.117647 20.6761 0.346225 21.2221C0.574803 21.768 0.909835 22.2641 1.33219 22.682C1.75455 23.0998 2.25596 23.4313 2.80779 23.6575C3.35963 23.8836 3.95108 24 4.54839 24C5.14569 24 5.73714 23.8836 6.28898 23.6575C6.84082 23.4313 7.34223 23.0998 7.76458 22.682C8.18694 22.2641 8.52197 21.768 8.75055 21.2221C8.97913 20.6761 9.09677 20.0909 9.09677 19.5Z"
      fill="#666666"
    />
  </svg>
);

export const InvestmentsIcon: SvgIcon = ({
  width = 25,
  height = 25,
  strokeColor = "text-black",
  fillColor = "#00000000",
  classes,
  onClick
}) => (
  <svg
    onClick={onClick}
    width={width}
    height={height}
    fill={fillColor}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 93 87"
    className={`fill-current ${strokeColor} ${classes}`}
  >
    <g clipPath="url(#clip0_327_162)">
      <path
        opacity="0.4"
        d="M64.046 74.7451C65.2008 75.8986 65.1132 77.857 63.7811 78.7999C57.1123 83.536 49.1536 86.1239 40.971 86.2171C19.3611 86.4847 0.75908 68.7912 0.0239705 47.2147C-0.690907 26.2058 14.6688 8.67544 34.7595 5.83988C36.3529 5.61426 37.7675 6.93605 37.7675 8.5441V48.4995L64.046 74.7451Z"
        fill="#828284"
      />
      <path
        d="M86.3289 37.5882C84.933 17.4733 68.838 1.39956 48.6967 0.00536239C47.1591 -0.0939826 45.8643 1.20087 45.8643 2.73987V40.4169H83.5926C85.1335 40.4169 86.4283 39.1237 86.3289 37.5882ZM88.9913 48.4992H48.9834L75.6227 75.1034C76.6343 76.1137 78.3203 76.2029 79.364 75.2179C86.0538 68.9412 90.4027 60.5757 91.6939 51.4998C91.9248 49.9119 90.6013 48.4992 88.9913 48.4992Z"
        fill="#828284"
      />
    </g>
    <defs>
      <clipPath id="clip0_327_162">
        <rect width="93" height="87" fill="white" />
      </clipPath>
    </defs>
  </svg>
);
